import React, { useEffect, useState } from "react";
import { SelectDropdown } from "commons/input-controls";
import s from "./data-fields.module.scss";

const DataFields = (props) => {

    const getFieldsName = (fields) => {
        
        let fieldsList = fields.map(k =>    {   return {
                                                    name: k.name ? props.getValue(k.name) : props.getValue(k), 
                                                    title: k.name ? k.name : k, 
                                                    list: k.list ? k.list : k
                                                }
                                            });
        return fieldsList;
    }

    const [dateItems, setDateItems] = useState(props.dateFields);

    const [selectedFirst, setSelectedFirst] = useState(props.parameters && props.parameters.fields ? props.getValue(props.parameters.fields[0]) : null);
    const [selectedSecond, setSelectedSecond] = useState(props.parameters && props.parameters.fields && props.parameters.fields[1] ? props.getValue(props.parameters.fields[1]) : null);
    const [selectedDate, setSelectedDate] = useState(props.parameters && props.parameters.dateField ? props.getValue(props.parameters.dateField) : null);
    const [parameters, setParameters] = useState(props.parameters && props.parameters ? props.parameters : null);
    const [articles, setArticles] = useState(props.articles ? props.articles : null);
    const [fields, setFields] = useState(getFieldsName(props.fields));
    const [dates, setDates] = useState(getFieldsName(dateItems));

    useEffect(() => {
        //setSelectedFirst(props.parameters && props.parameters.fields ? props.getValue(props.parameters.fields[0]) : null);
        //setSelectedSecond(props.parameters && props.parameters.fields && props.parameters.fields[1] ? props.getValue(props.parameters.fields[1]) : null);
        //setSelectedDate(props.parameters && props.parameters.dateField ? props.getValue(props.parameters.dateField) : null);
        setParameters(props.parameters && props.parameters ? props.parameters : null);
        setArticles(props.articles ? props.articles : null);
        setFields(getFieldsName(props.fields));
        setDateItems(props.dateFields);
        setDates(getFieldsName(dateItems));
    }, [props]);

    const getListName = (field) => {
        let findedField = fields.filter(k => k.name == field);
        return findedField ? findedField[0] : field;
    }

    const updateFirstField = (firstField) => {
        let params = parameters;
        let fields = [...params.fields];
        let first = params.fields[0]
        let second = params.fields[1] ? params.fields[1] : null;
        first = firstField.list;
        fields[0] = first;
        params.fields = fields;
        props.setParameters(props.type, 'fields', fields)
        
        //props.setParameters(props.type, 'fields', firstField.list);
    }

    const updateSecondField = (secondField) => {
        let params = parameters;
        let fields = [...params.fields];
        let second = params.fields[1] ? params.fields[1] : null;
        second = secondField.list;
        fields[1] = second;
        params.fields = fields;
        props.setParameters(props.type, 'fields', fields)
    }

    const updateDateField = (dateField) => {
        let params = parameters;
        let dateFieldP = {...params.dateField}
        dateFieldP = dateField.list;
        params.dateField = dateFieldP;
        props.setParameters(props.type, 'dateField', params.dateField)
    }

    return (
        <div className={s.DataFields}>
            <div className={s.selectData}>
                <div className={s.formRow}>
                    <span>{props.getValue('SELECT_DATA_ROWS')} (№1) {articles && articles.first ? (parameters.dateField ? props.getValue(articles.second) : props.getValue(articles.first)) : null}</span>
                    <div className={s.selectRow}>
                        <SelectDropdown height={200} showOnly={props.readOnly} width={113} items={fields} selected={parameters.fields && parameters.fields[0] ? props.getValue(parameters.fields[0]) : null} setSelected={updateFirstField}/>
                    </div>
                </div>
                { props.availableFields.indexOf('second') !== -1
                ?   <div className={s.formRow}>
                        <span>{props.getValue('SELECT_DATA_ROWS')} (№2) {articles && articles.second && !parameters.dateField ? props.getValue(articles.second) : null}</span>
                        <div className={s.selectRow}>
                            <SelectDropdown height={200} items={fields} selected={props.parameters && props.parameters.fields  && props.parameters.fields[1] ? props.getValue(props.parameters.fields[1]) : null} setSelected={updateSecondField} showOnly={((parameters.dateField && parameters.dateField !== '') || props.readOnly) ? true : false} />
                        </div>
                    </div>
                : null }

            </div>
            { props.availableFields.indexOf('dateField') !== -1 ? <div className={s.selectData}>
                <div className={s.formRow}>
                    <span>{props.getValue('SELECT_DATA_ROW')} {articles && parameters.dateField && articles.dateField ? props.getValue(articles.dateField) : null}</span>
                    <div className={s.selectRow}>
                        <SelectDropdown showOnly={props.readOnly} items={dates} selected={props.parameters && props.parameters.dateField ? props.getValue(props.parameters.dateField) : null} setSelected={updateDateField}/>
                    </div>
                </div>
            </div> : null }
            { parameters.dateField ? <div className={s.warningBlock}>
                <span>{props.getValue('ONLY_ONE_DATA_FIELD_IS_ALLOWED')}</span>
            </div> : null }
        </div>
    )
}

export default DataFields;